import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { JobRecommendationCategoriesActions } from './models/job-recommendation-categories-actions.model';
import { JobRecommendationTasksGrid } from './models/job-recommendation-tasks-grid.model';
import { FetchArgs } from 'src/app/shared/models/core';
import { generateQuery } from 'src/app/shared/utilities/grid-query-params';
import { JobRecommendationCustomAction } from './models/job-recommendation-custom-action.model';

@Injectable({
    providedIn: 'root'
})
export class JobRecommendationsService {
    private readonly _coreApiPath: string;

    constructor(private readonly _httpClient: HttpClient, @Inject(APP_CONFIG) private readonly _settings: Settings) {
        this._coreApiPath = combine(this._settings.coreAPIUrl, 'AyaNova');
    }

    loadRecommendations(jobId: number): Observable<JobRecommendationCategoriesActions[]> {
        const url = `${this._coreApiPath}/job-fulfillment-recommendations/job/${jobId}`;
        return this._httpClient.get<JobRecommendationCategoriesActions[]>(url);
    }

    updateRecommendation(
        recommendation: JobRecommendationCategoriesActions
    ): Observable<JobRecommendationCategoriesActions> {
        const url = `${this._coreApiPath}/job-fulfillment-recommendations/action/${recommendation.actionId}`;
        return this._httpClient.put<JobRecommendationCategoriesActions>(url, recommendation);
    }

    getRecommendationTasks(args: FetchArgs): Observable<JobRecommendationTasksGrid> {
        const url = `${this._coreApiPath}/job-fulfillment-recommendations`;

        const params = generateQuery(args);
        return this._httpClient.get<JobRecommendationTasksGrid>(url, { params });
    }

    createCustomAction(action: JobRecommendationCustomAction) {
        const url = `${this._coreApiPath}/job-fulfillment-recommendations/custom/action`;
        return this._httpClient.post<number>(url, action);
    }
}
